import type {IWorkMode} from "~/shared/interfaces/search/products";

export default function getWorkMode(workModeArray: IWorkMode[], htmlStyle?: {
  isBold?: boolean,
  lineBreak?: boolean,
}) {
  const { isBold, lineBreak } = htmlStyle || {};
  let days: string[] = [];
  let workModeHTMLList: string[] = [];

  const tagWrapper = isBold ? 'b' : 'span';
  const lineBreakItem = lineBreak ? '</br>' : ', ';

  const getWorkModeTemplate = (yesterday: IWorkMode) => {
    workModeHTMLList.push(`<${tagWrapper}>${days.length > 1 ? `${days.at(0)}-${days.at(-1)}` : `${days.at(0)}`}: ${yesterday.start}-${yesterday.end}</${tagWrapper}>`);
    days = []
  }

  if (workModeArray.length) {
    workModeArray.forEach((today, i) => {
      const yesterday = workModeArray[i - 1]

      if ((yesterday && today.start === yesterday.start && today.end === yesterday.end) || i === 0) {
        days.push(today.day)
        if (days.length === 7 && today.start !== null) {
          getWorkModeTemplate(yesterday)
        }
      } else if ((today.start !== yesterday.start || today.end !== yesterday.end) && today.start !== null) {
        getWorkModeTemplate(yesterday)
        days.push(today.day)
      } else if (today.start === null) {
        getWorkModeTemplate(yesterday)
      }
    })

    return workModeHTMLList.join(lineBreakItem);
  }
}
